export default __webpack_public_path__ + "img/banana.00ff88c8.svg";